import React from 'react'
import { Typography, Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material'

export interface CheckboxProps {
  label?: string
  value?: boolean
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void
}

export const Checkbox = ({ label, value, onChange }: CheckboxProps): React.ReactElement => {
  return (
    <FormControlLabel
      label={
        label && (
          <Typography variant="body1" color="text.primary">
            {label}
          </Typography>
        )
      }
      control={<MuiCheckbox checked={value} onChange={onChange} />}
    />
  )
}
